import classNames from 'classnames';

const MenuItemUOM = ({ className, usePrimaryColor = false, showBackground = true, uom }) => {
    const style = {
        padding: '3px 8px',
        borderRadius: '8px'
    };

    if (showBackground) {
        style.backgroundColor = '#F3F4F6';
    }

    const classes = classNames(
        'ms-2',
        {
            'text-primary': usePrimaryColor,
            'text-muted': !usePrimaryColor
        },
        className
    );

    return (
        <span className={classes} style={style}>
            {uom}
        </span>
    );
};

export default MenuItemUOM;
